import { useCallback } from 'react'

/** @param {{ setMainAskBarPrefill: Function }} m */
export function useMainAskBarPrefillAction(m) {
  const { setMainAskBarPrefill } = m
  const handleMainAskBarPrefill = useCallback((payload) => {
    const text = String(payload?.text ?? '')
    const next = { text, nonce: Date.now() }
    if (payload?.connectContext) {
      next.connectContext = payload.connectContext
    }
    setMainAskBarPrefill(next)
  }, [setMainAskBarPrefill])
  return { handleMainAskBarPrefill }
}
